import { Priorities } from '../constants-repository/priority-values.constants';

export const PRIORITY_LABELS: Record<Priorities, string> = {
  [Priorities.High]: 'Hoch',
  [Priorities.Medium]: 'Mittel',
  [Priorities.Low]: 'Niedrig',
};

export function getPriorityLabel(priority: `${Priorities}`) {
  return PRIORITY_LABELS[priority];
}
